import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';


@Component({
	selector: "app-footer",
	templateUrl: "./footer.component.html",
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class FooterComponent implements OnInit {


	constructor() {

	}
	ngOnInit() {

	}

}